<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{ disable?: boolean }>()
</script>

<template>
  <div
    v-if="umsokn"
  >
    <v-row>
      <v-col>
        <h2 class="form__header">
          {{ t('makalifeyrir_umsokn_step6_header') }}
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <p class="forms__paragraph">
          {{ t('makalifeyrir_umsokn_step6_text') }}
        </p>
        <p>
          {{ t('makalifeyrir_umsokn_step6_text2') }}
        </p>
        <a
          class="subpage__applicationLink"
          target="_blank"
          href="/barnalifeyrir"
        >
          {{ t('makalifeyrir_umsokn_step6_text3') }}
        </a>
        <p>
          {{ t('makalifeyrir_umsokn_step6_text4') }}
        </p>
        <p class="forms__paragraph">
          {{ t('makalifeyrir_umsokn_step6_text5') }}
        </p>
      </v-col>
    </v-row>
  </div>
</template>
